
        import 'Expander.0fe6196.css-module'
        export default {"Expander":"Expander_Expander_0fe6196"}
    